import { useState } from "react";

import Button from "react-bootstrap/Button";
import InfoCase from "./InfoCaseDetail";

const ItemsCases = ({ cases }) => {
  const [showLoading, setShowLoading] = useState(false);
  const [show, setShow] = useState(false);

  const formatDate = (date) => {
    const dateD = new Date(date);
    return dateD.toLocaleDateString();
  };

  const openCaseDetail = () => {
    setShowLoading(true);
    setTimeout(() => {
      setShowLoading(false);
      setShow(true);
    }, 600);
    return;
  };

  return (
    <>
      <li className="character-item">
        <div className="character-card">
          <h3 style={{ fontSize: "13px" }}>
            N° de caso:{" "}
            <b style={{ color: `${cases.status !== 1 ? "red" : "#008b9c"}` }}>
              {cases.case_number}
            </b>
          </h3>
          <hr style={{ margin: "4px 0px" }} />
          <h3 style={{ fontSize: "12px" }}>
            Relación con la compañia: {cases.relationship_with_the_company}
          </h3>
          <h3 style={{ fontSize: "12px" }}>Ciudad: {cases.city}</h3>
          <h3 style={{ fontSize: "12px" }}>
            Fecha de creación: {formatDate(cases.create_date)}
          </h3>
          {showLoading ? (
            <div className="container-sniper"></div>
          ) : (
            <>
              <Button
                style={{
                  marginBottom: "10px",
                  backgroundColor: "#90d400",
                  border: "0px",
                  width: "60%",
                  height: "30px",
                  alignContent: "center",
                  justifyContent: "center",
                  fontSize: "13px",
                }}
                type="submit"
                onClick={() => openCaseDetail()}
              >
                Ver mas
              </Button>
              <InfoCase
                open={show}
                onOpen={(state) => setShow(state)}
                data={cases}
              />
            </>
          )}
        </div>
      </li>
    </>
  );
};

export default ItemsCases;
